import { type ReactNode } from 'react';
import { PageLayout } from './PageLayout';
import { PageHeader, type BreadcrumbItem } from './PageHeader';

export interface SettingsPageLayoutProps {
  title: string;
  subtitle?: string;
  icon?: ReactNode;
  actions?: ReactNode;
  backTo?: string;
  backLabel?: string;
  children: ReactNode;
  contentBackground?: string;
}

export function SettingsPageLayout({
  title,
  subtitle,
  icon,
  actions,
  backTo,
  backLabel,
  children,
  contentBackground,
}: SettingsPageLayoutProps) {
  const breadcrumbs: BreadcrumbItem[] | undefined = backTo
    ? [{ label: backLabel || 'Back', href: backTo }, { label: title }]
    : undefined;

  return (
    <PageLayout
      variant="centered"
      contentBackground={contentBackground}
      header={
        <PageHeader
          title={title}
          subtitle={subtitle}
          icon={icon}
          actions={actions}
          breadcrumbs={breadcrumbs}
          borderStyle="bottom"
        />
      }
    >
      <div className="py-6 animate-fade-in">
        {children}
      </div>
    </PageLayout>
  );
}

export default SettingsPageLayout;
